import { ITermCoursesDatasource } from '../../../../term_courses/datasources/term_courses_datasource';
import { ISectionsDatasource } from '../../../../sections/datasources/sections_datasource';
import { ISectionAvailabilityDatasource } from '../../../../sections/datasources/section_availability_datasource';
import { ScheduledSectionStatus } from '../../../types/scheduled_section_status_enum';
import { IWaitlistStatusDatasource } from '../../../datasources/waitlist_status_datasource';
import { IQueryMediator, IDefineCommand } from 'core-ts-types';
angular
  .module('capability-ng-scheduler')
  .service(
    'saveSuggestionsCommand',
    function saveSuggestionsCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngWaitlistStatusDatasource: IWaitlistStatusDatasource,
      ngSectionsDatasource: ISectionsDatasource,
      ngTermCoursesDatasource: ITermCoursesDatasource,
      QueryMediator: IQueryMediator,
      ngSectionAvailabilityDatasource: ISectionAvailabilityDatasource,
      log: any
    ) {
      return defineCommandORM('saveSuggestionsCommand', (deferred, termId: number, sectionIds: number[]) => {
        $http
          .post('/reg/scheduler/term/' + termId + '/', {
            schedule: sectionIds
          })
          .then(() => {
            sectionIds.forEach((sectionId) => {
              const section = ngSectionsDatasource.get(sectionId);
              if (!section) {
                return;
              }

              section.status = ScheduledSectionStatus.SECTION_PICKED;
              const sectionToScheduleAvailability = ngSectionAvailabilityDatasource.get(section.id);
              if (!sectionToScheduleAvailability) {
                return;
              }
              const {
                id,
                is_seat_available,
                is_waitlist_allowed,
                is_waitlist_full,
                is_auto_waitlist,
                avail_seats,
                last_refresh_ts,
                linked_section_coreqs_satisfied,
                has_linked_section_coreqs
              } = sectionToScheduleAvailability;

              ngWaitlistStatusDatasource.put({
                id,
                is_seat_available,
                is_waitlist_allowed,
                is_waitlist_full,
                is_auto_waitlist,
                avail_seats,
                last_refresh_ts,
                linked_section_coreqs_satisfied,
                has_linked_section_coreqs
              });
            });
            return QueryMediator.runQueries(ngTermCoursesDatasource);
          })
          .then(() => deferred.resolve())
          .catch((e: any) => {
            log.issue('failed to save suggestions');
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/modals/suggestions/commands/save_suggestions_command.ts